import React, { Component } from 'react'
import { Button, Col, Input, Label, Row } from 'reactstrap'
import AssocDessocStore from '../stores/AssocDessocStore'
import ModalForm from '../../comum/components/ModalForm'
import SelectFiltro from '../../comum/components/SelectFiltro'
import FormOnlyPositiveNumberSimples from '../../comum/components/FormNumberSimples'
import { observer } from 'mobx-react'
import { IconeCarregar, IconeDelete } from '../../comum/components/Icones'
import FormSelectSimples from '../../comum/components/FormSelectSimples'

@observer
export default class ModalAssociacaoDepot extends Component {

    constructor(props) {
        super(props)

        this.depotController = this.props.controller
        
        this.controller = new AssocDessocStore(this.depotController.listaDefault, this.depotController.bookingSelecionado, this.depotController.dadosOpSelecionada, this.depotController.modo)

        this.handleSalvar = this.handleSalvar.bind(this)
        this.controller.listarArmadores()
        this.controller.listarDepot()
    }

    handleSalvar() {
        this.controller.salvando = true
        if(this.depotController.modo === "Desassoc"){
            this.depotController.desassocicarBooking(this.controller.qtdDesassociar)
        }else if(this.depotController.modo === "Assoc"){
            this.depotController.associarBooking(this.controller.qtdAssociar, this.controller.depotSelecionado.value)
        }else if(this.depotController.modo === "AssocDefault"){
            this.depotController.salvarDepotDefault(this.controller.listaDefault)
        }
    }

    renderAssoc() {
        return (
            <React.Fragment>
                <h2>Associar Depot/Booking</h2>
                <Row>
                <FormOnlyPositiveNumberSimples xs={12} sm={12} md={6} lg={6} xl={6}
                    titulo="Qtd. para associar"
                    onChange={(event) => this.controller.setQtdAssoc(event.target.value)}
                />
                <SelectFiltro xs={12} sm={12} md={6} lg={6} xl={6}
                    titulo="Depot"
                    itens={this.controller.listaDepot}
                    onChange={(event) => this.controller.setDepotAssoc(event)}
                    itensValor="value"
                    itensLabel="label"
                />
                <Col>
                    <Label>
                        <span className="btn-enviar">{this.depotController.bookingSelecionado.Associacao.RbdQtdCntr}</span> Disponíveis para associar
                    </Label>
                </Col>
                </Row>
            </React.Fragment>
        )
        
    }

    renderDesassoc() {
        return (
            <React.Fragment>
                <h2>Desassociar Depot/Booking</h2>
                <Row>
                    <FormOnlyPositiveNumberSimples xs={12} sm={12} md={6} lg={6} xl={6}
                        titulo="Qtd. para desassociar"
                        onChange={(event) => this.controller.setQtdDesassoc(event.target.value)}
                    />
                <Col xs={12} sm={12} md={6} lg={6} xl={6}>
                    <Label>Depot</Label>
                    <Input value={this.depotController.bookingSelecionado.Associacao.ApelidoDepot} disabled />
                </Col>
                <Col>
                    <Label>
                        <span className="btn-enviar">{this.depotController.bookingSelecionado.Associacao.RbdQtdCntr}</span> Associados
                    </Label>
                </Col>
                </Row>
            </React.Fragment>
        )

    }

    renderAssocDefault() {
        return (
            <React.Fragment>
                <h2>Associar armador ao depot default</h2>
                    {
                        this.controller.listaDefault.map((defaultDepot, index) => {
                            return(
                                <Row key={index} className="align-items-center">
                                    <FormSelectSimples xs={12} sm={12} md={5} lg={5} xl={5}
                                        titulo="Armador"
                                        itens={this.controller.listaArmadores}
                                        dado={defaultDepot.armador}
                                        onChange={(event) => this.controller.setDepotDefault(event, defaultDepot, "armador")}
                                        />
                                    <FormSelectSimples xs={10} sm={10} md={5} lg={5} xl={5}
                                        titulo="Depot default"
                                        itens={this.controller.listaDepot}
                                        dado={defaultDepot.depot}
                                        onChange={(event) => this.controller.setDepotDefault(event, defaultDepot, "depot")}
                                    />
                                    <Col xs={1} sm={1} md={2} lg={2} xl={2} className="pl-0 mt-1">
                                        <IconeDelete className="icone-delete-borda" tamanho="3x" onClick={ () => this.controller.delArmador(index) }/>
                                    </Col>
                                </Row>
                            )
                        })
                    }
                    <Row>
                            <Button className="btn-primary" onClick={this.controller.addArmadorNovo}>
                                + Adicionar armador
                            </Button>
                    </Row>
            </React.Fragment>
        )
    }

    renderModal() {
        switch(this.depotController.modo){
            case 'Assoc':
                return this.renderAssoc()
            case 'Desassoc':
                return this.renderDesassoc()
            case 'AssocDefault':
                return this.renderAssocDefault()
            default:
                return null
        }
    }

    render() {
        return (
            <ModalForm
                salvando={this.depotController.loadingModal}
                className="modal-direcionamento"
                onClickSalvar={this.handleSalvar}
                onClickCancelar={this.depotController.fecharModalAssoc}
            >
                { this.renderModal() }
            </ModalForm>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/bookingdepot/components/ModalAssociacaoDepot.js